// Shared "Connect Google Drive" authorization-code flow - used by both
// AccountSettings.js's "Connect Drive" button and (native background-upload
// feature, Flow 5) EventPage.js's Drive-picker prompt, which offers to
// connect Drive first so its upload can go through the backgroundable
// server-side relay instead of the foreground-only client-token path. One
// copy of the initCodeClient dance instead of two.
import profileApi from '../pages/Profile/profileApi';

function loadGis() {
  return new Promise((resolve) => {
    if (window.google?.accounts?.oauth2) { resolve(); return; }
    const s = document.createElement('script');
    s.src = 'https://accounts.google.com/gsi/client';
    s.onload = resolve;
    s.onerror = resolve;
    document.head.appendChild(s);
  });
}

// Runs the full popup consent flow and exchanges the resulting code
// server-side (see cm_backend_utils/google_drive.py's exchange_drive_auth_code),
// storing an encrypted refresh token for the current user. Throws on failure;
// resolves with `{ driveEmail }` on success.
export async function connectDriveAccount() {
  await loadGis();
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  if (!clientId) throw new Error('Google Client ID not configured.');

  const authCode = await new Promise((resolve, reject) => {
    const client = window.google.accounts.oauth2.initCodeClient({
      client_id: clientId,
      // drive.file (not full drive scope) + access_type=offline/prompt=consent
      // (set implicitly by initCodeClient requesting a code) so Google issues
      // a refresh token alongside the code - see google_drive.py's own comment.
      scope: 'https://www.googleapis.com/auth/drive.file email',
      ux_mode: 'popup',
      select_account: true,
      callback: (response) => {
        if (response.error) reject(new Error(response.error_description || response.error));
        else resolve(response.code);
      },
    });
    client.requestCode();
  });

  const result = await profileApi.connectDrive(authCode, 'postmessage');
  return { driveEmail: result.drive_email || '' };
}
